import '../SingleInnerIndustries.scss';

import { FC, useRef } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { PATH, RouteParams } from '../../../../../router';
import { mutationMainForm } from '../../../../../network';
import { cn } from '../../../../../ui/utils/bem';
import { Breadcrumbs } from '@dataartdev/uikit/Breadcrumbs';
import { TreeNav } from '@dataartdev/uikit/TreeNav';
import { Typography } from '@dataartdev/uikit/Typography';
import { Mq } from '@dataartdev/uikit/Mq';
import { ISingleInnerIndustries } from '../models';
import { ContentBuilder } from '../../../../../common/components/ContentBuilder/ContentBuilder';
import {
  recaptchaFormKey,
  recaptchaKey,
} from '../../../../../common/constants';
import { useGTMDataSend } from '../../../../../common/hooks';
import { useLetsTalkFormDictionary } from '../../../../../common/hooks/useLetsTalkFormDictionary';

const cnPage = cn('SingleInnerIndustries');

type Props = RouteComponentProps<RouteParams> & {
  loading: boolean;
  data: ISingleInnerIndustries | null;
};

export const OfferingPage: FC<Props> = ({ data, history, loading }) => {
  const { breadcrumbs, tags, metaTitle, content, title, subtitle } = data || {};
  const {
    companySiteTableOfContent,
    dictionariesForm,
  } = useLetsTalkFormDictionary();
  const pageRef = useRef(null);

  useGTMDataSend(metaTitle, tags);

  return (
    <>
      {!loading && (
        <div className={cnPage()}>
          <Mq query="--desktop">
            <TreeNav
              title={companySiteTableOfContent}
              pageRef={pageRef}
              fixed
            />
          </Mq>
          <div className="container">
            {breadcrumbs && (
              <Breadcrumbs
                getLabel={page => page.text}
                getLink={page => page.url}
                history={history}
                pages={breadcrumbs}
              />
            )}
          </div>

          <div className="container SingleInnerIndustries-Nogap">
            <Typography.Title size="hg" as="h1">
              {title}
            </Typography.Title>
            <Typography.Text as="p">{subtitle}</Typography.Text>
          </div>
          <ContentBuilder
            items={content}
            aliases={PATH}
            recaptchaKey={recaptchaKey}
            onSubmitForm={async body =>
              await mutationMainForm({
                body: { ...body, pageId: data?.id },
                [`${recaptchaFormKey}`]: body.token,
              })
            }
            pageId={data?.id}
            dictionariesForm={dictionariesForm}
          />
        </div>
      )}
    </>
  );
};
